import { noop } from "lodash-es"
import { createContext, useState, useCallback, PropsWithChildren } from "react"
import type { ApiErrorContextType, ErrorType } from "./types"

export const APIErrorContext = createContext<ApiErrorContextType>({
  error: null,
  addError: noop,
  removeError: noop,
})

export const APIErrorProvider = ({ children }: PropsWithChildren<unknown>) => {
  const [error, setError] = useState<ErrorType | null>(null)

  const removeError = () => setError(null)

  const addError = (message: string, device = "modal") => setError({ message, device })

  const contextValue = {
    error,
    addError: useCallback((message: string, device?: string) => addError(message, device), []),
    removeError: useCallback(() => removeError(), []),
  }

  return <APIErrorContext.Provider value={contextValue}>{children}</APIErrorContext.Provider>
}
